import {LookerEmbedSDK} from '@looker/embed-sdk';
import {API} from 'aws-amplify';
import {toast} from 'react-toastify';

let isSDKInitialized = false;
let lookerTokens = null;

export const ensureLookerSDKInitialized = () => {
    if (isSDKInitialized) return;

    LookerEmbedSDK.initCookieless(
        window.__RUNTIME_CONFIG__.LOOKER_API_HOST,
        acquireEmbedSessionCallback,
        generateEmbedTokensCallback
    );

    isSDKInitialized = true;
};

const acquireEmbedSessionCallback = async () => {
    try {
        const response = await API.get('Core', '/api/v1/looker/acquire_embed_cookieless_session');
        lookerTokens = response;
        return response;
    } catch (error) {
        toast.error(`Failed to acquire Looker session: ${error?.response?.data?.message || error.message}`, {
            position: "top-center",
        });
        throw error;
    }
};

const generateEmbedTokensCallback = async () => {
    try {
        const {api_token, navigation_token} = lookerTokens;
        const response = await API.put(
            'Core',
            '/api/v1/looker/generate_tokens_for_cookieless_session',
            {
                body: {api_token, navigation_token}
            }
        );
        lookerTokens = response;
        return response;
    } catch (error) {
        const status = error?.response?.status || error?.status;
        if (status === 400) {
            return {session_reference_token_ttl: 0};
        }
        toast.error(`Failed to generate Looker session: ${error?.response?.data?.message || error.message}`, {
            position: "top-center",
        });
        throw error;
    }
};
